import { ClubApi } from 'api'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import { TopLevelPage, ModelGrid } from 'ui'
import useForceUpdate from 'hooks/useForceUpdate'

const Clubs = ({ match }) => {
  const forceUpdate = useForceUpdate()
  const queryRef = useRef(ClubApi.paramsFor('index').q)

  const queryDidChange = query => { queryRef.current = query }
  const queryWouldSubmit = () => { forceUpdate() }

  let { id, eventId } = match.params
  let models = ClubApi.kick('index', { q: queryRef.current })

  return (
    <TopLevelPage className="Parks" modelId={eventId || id} base={eventId ? `/clubs/${id}` : '/clubs'}>
      <div className="row">
        <div className="col-sm-6 col-lg-4 col-xl-3">
          <SearchBar onChange={queryDidChange} onSubmit={queryWouldSubmit} initialQuery={queryRef.current} />
        </div>
      </div>
      <ModelGrid models={models} base={'clubs'} />
    </TopLevelPage>
  )
}

Clubs.propTypes = {
  match: PropTypes.object
}

export default withErrorBoundary(connected(Clubs))
